var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 402.04 392.38",
    style: {
      enableBackground: "new 0 0 402.04 392.38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M388.6,83.84l-72.62-70.88c-7.43-7.14-17.34-11.13-27.65-11.13c-10.31,0-20.22,3.99-27.65,11.13L49.63,218.93 c-1.67,1.9-2.98,4.1-3.85,6.48L3.43,350.89c-1.85,5.34-2.16,11.09-0.89,16.61c1.27,5.51,4.06,10.55,8.07,14.54 c4.09,4.08,9.22,6.97,14.83,8.36c5.61,1.39,11.49,1.22,17.02-0.48l128.1-40.95c1.87-0.64,3.6-1.66,5.07-2.98h1.4l211.58-207.02 c7.47-7.22,11.7-17.17,11.7-27.56C400.3,101.01,396.08,91.07,388.6,83.84L388.6,83.84z M166,307.84l-79.1-76.3l152.77-149.1 l78.4,76.48L166,307.84z M39.12,354.04l30.45-90.82l62.65,61.07L39.12,354.04z M364.1,113.77l-20.82,20.48l-78.4-76.48l20.3-19.77v0 c0.82-0.86,1.96-1.34,3.15-1.34s2.32,0.48,3.15,1.34l72.63,71.05c0.8,0.55,1.29,1.47,1.29,2.45c0,0.98-0.48,1.89-1.29,2.45 L364.1,113.77z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.fb65b7c9dc76f442d04e37ad59989661.svg";
export { ForwardRef as ReactComponent };